import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { DialogService } from '@markant-platform/shared/dialog/feature';
import { Router } from '@angular/router';
import { ErrorMessage } from '@markant-platform/shared/error-model';

@Injectable()
export class VersionMismatchInterceptor implements HttpInterceptor {
  constructor(
    private readonly dialogService: DialogService,
    private readonly router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 409 && error.error?.message === ErrorMessage.VERSION_MISMATCH) {
          this.dialogService.showErrorDialog(
            'error.versionMismatch.headline',
            'error.versionMismatch.text',
            'error.versionMismatch.buttonLabel',
            this.reloadPage.bind(this)
          );
        }
        throw error;
      })
    );
  }

  private async reloadPage(): Promise<void> {
    const currentUrl = this.router.url;

    await this.router.navigateByUrl('/', { skipLocationChange: true });
    await this.router.navigateByUrl(currentUrl);
  }
}
